import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { confirm } from "../../../Layout/Dialog/ConfirmDialog";
import OpeningTime, { defaultOpeningTime } from "../../../OpeningTimes/OpeningTime";
import { useDeleteSupplierOpeningTime } from "../../Hooks/useDeleteSupplierOpeningTime";
import { SmallAddButton } from "../../../Layout/Buttons/SmallAddButton";
import { SupplierOpeningTimeForm } from "./SupplierOpeningTimeForm";
import { useFetchSupplierOpeningTimes } from "../../Hooks/useFetchSupplierOpeningTimes";
import { BorderedGridItemWithMessage } from "../../../Grid/BorderedGridItemWithMessage";
import { OpeningTimesFormProps } from "../../../OpeningTimes/OdcFormProps";
import { useIsUserInRoles } from "../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export const SupplierOpeningTimesParentForm = ({ parentId }: OpeningTimesFormProps) => {
  const [addedOpeningTimes, setAddedOpeningTimes] = useState<OpeningTime[]>([]);

  const {
    data: existingOpeningTimes,
    isLoading: isLoadingOpeningTimes,
    isSuccess: openingTimesLoaded,
  } = useFetchSupplierOpeningTimes(parentId);

  const addOpeningTime = (newOpeningTime: OpeningTime) => {
    setAddedOpeningTimes((current) => [newOpeningTime, ...current]);
  };

  const [queryResult, setQueryResult] = useState<string>("");
  useEffect(() => {
    if (isLoadingOpeningTimes) setQueryResult("Loading opening times for Supplier ...");
  }, [isLoadingOpeningTimes]);

  useEffect(() => {
    if (existingOpeningTimes) {
      setQueryResult("No Opening Times exist for this Supplier yet");
    }
  }, [existingOpeningTimes, openingTimesLoaded]);

  const { mutateAsync: deleteOpeningTime } = useDeleteSupplierOpeningTime();

  const deleteOpeningTimeWithToast = async (openingTime: OpeningTime) => {
    if (await confirm("Do you really want to delete the current opening time?")) {
      await deleteOpeningTime(openingTime);
    }
  };

  const concatenatedOpeningTimes = [...addedOpeningTimes].concat(existingOpeningTimes ?? []);

  const isUserAdminNetworkLaunch = useIsUserInRoles(
    AuthorizationPolicies.RequireAdminNetworkLaunchRoles
  );

  return (
    <>
      <SmallAddButton
        onClick={() => addOpeningTime({ ...defaultOpeningTime, ParentId: parentId } as OpeningTime)}
        disabled={
          !isUserAdminNetworkLaunch || isLoadingOpeningTimes || addedOpeningTimes.length !== 0
        }
      />

      <Grid item xs={12} container justifyContent="center">
        {concatenatedOpeningTimes.length === 0 ? (
          <BorderedGridItemWithMessage message={queryResult} />
        ) : (
          concatenatedOpeningTimes.map((openingTime) => (
            <Grid item xs={12} key={openingTime.Id}>
              <SupplierOpeningTimeForm
                key={openingTime.Id}
                initialValues={openingTime}
                deleteOpeningTimeHandler={deleteOpeningTimeWithToast}
                removeOpeningTimeFromParentStateAfterSave={() => setAddedOpeningTimes([])}
                isReadOnly={!isUserAdminNetworkLaunch}
              />
            </Grid>
          ))
        )}
      </Grid>
    </>
  );
};
